'use strict';

Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - onejan) / 86400000 + onejan.getDay() + 1) / 7);
  //return Math.round((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
};

Date.prototype.numDateWithoutTimeZone = function () {
  return this.getFullYear() * 10000 + (this.getMonth() + 1) * 100 + this.getDate();
};

function scrollTo(id, diff) {
  if (typeof id != 'string') {
    return false;
  }
  console.log('main', id);
  if ($(id).length == 0) {
    return false;
  };
  $('html, body').animate({ scrollTop: $(id).offset().top - diff }, 'slow');
  return false;
}

Array.prototype.sortByVariety = function (namespace) {
  if (namespace) {
    this.forEach(function (item) {
      item.namespace = eval('item.' + namespace);
    });
    return this.sort(function (a, b) {
      var compare1 = a.namespace.product_group.common_name.localeCompare(b.namespace.product_group.common_name);
      var compare2 = a.namespace.variety_name.localeCompare(b.namespace.variety_name);
      if (compare1 === 0) {
        return compare2;
      }
      return compare1;
    });
  } else {
    return this.sort(function (a, b) {
      var compare1 = a.product_group.common_name.localeCompare(b.product_group.common_name);
      var compare2 = a.variety_name.localeCompare(b.variety_name);
      if (compare1 === 0) {
        return compare2;
      }
      return compare1;
    });
  }
};

$(function () {
  //$('.fixed th').each(function(item){console.log(this)});
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    //console.log(scroll)
    if (scroll >= 16) {
      $('.f-tabs').addClass('fixed');
      $('.f-pane').addClass('fixed');
      $('.js-aside-filter').addClass('aside-fixed');
    } else {
      $('.f-tabs').removeClass('fixed');
      $('.f-pane').removeClass('fixed');
      $('.js-aside-filter').removeClass('aside-fixed');
    }
    // if(scroll>=80){
    //   $('.f-alert').removeClass('hidden');
    // }else{
    //   $('.f-alert').addClass('hidden');
    // }
    if (scroll >= 108) {
      $('.fixed-header-table .fixed').removeClass('hidden');
    } else {
      $('.fixed-header-table .fixed').addClass('hidden');
    }
  });

  $(window).resize(function () {
    var width_array = [];
    $('.fixed').width($('.title-heading').width());
    $('.title-heading th').each(function (index) {
      width_array[index] = $(this).width();
    });
    $('.fixed th').each(function (index) {
      $(this).width(width_array[index]);
    });
  });
});
//# sourceMappingURL=main.js.map

'use strict';

(function () {
  var SbxCore = /** @class */function () {
    function SbxCore() {
      this.urls = {
        update_password: '/user/v1/password',
        login: '/user/v1/login',
        register: '/user/v1/register',
        validate: '/user/v1/validate',
        row: '/data/v1/row',
        find: '/data/v1/row/find',
        update: '/data/v1/row/update',
        delete: '/data/v1/row/delete',
        downloadFile: '/content/v1/download',
        uploadFile: '/content/v1/upload',
        addFolder: '/content/v1/folder',
        folderList: '/content/v1/folder',
        send_mail: '/email/v1/send',
        payment_customer: '/payment/v1/customer',
        payment_card: '/payment/v1/card',
        payment_token: '/payment/v1/token',
        password: '/user/v1/password/request',
        cloudscript_run: '/cloudscript/v1/run'
      };
    }
    SbxCore.prototype.initialize = function (domain, appKey, baseUrl) {
      if (baseUrl === void 0) {
        baseUrl = 'https://sbxcloud.com/api';
      }
      SbxCore.environment.domain = domain;
      SbxCore.environment.baseUrl = baseUrl;
      SbxCore.environment.appKey = appKey;
    };
    SbxCore.prototype.with = function (model) {
      return new Find(model, SbxCore.environment.domain);
    };
    SbxCore.prototype.insert = function (model, data, letNull) {
      return this.queryBuilderToInsert(data, letNull).setModel(model).compile();
    };
    SbxCore.prototype.encodeEmails = function (email) {
      var spl = email.split('@');
      if (spl.length > 1) {
        email = encodeURIComponent(spl[0]) + '@' + spl[1];
      }
      return email;
    };
    SbxCore.prototype.validateLogin = function (login) {
      var rlogin = /^(\w?\.?\-?)+$/;
      return rlogin.test(login);
    };
    SbxCore.prototype.validateEmail = function (email) {
      var rlogin = /^(\w?\.?\-?\+?)+@(\w?\.?\-?)+$/;
      return rlogin.test(email);
    };
    /**
     * UTILS
     */
    SbxCore.prototype.queryBuilderToInsert = function (data, letNull) {
      var _this = this;
      var query = new QueryBuilder().setDomain(SbxCore.environment.domain);
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          query.addObject(_this.validateData(item, letNull));
        });
      } else {
        query.addObject(this.validateData(data, letNull));
      }
      return query;
    };
    SbxCore.prototype.validateData = function (data, letNull) {
      var temp = {};
      Object.keys(data).filter(function (key) {
        var v = data[key];
        return (Array.isArray(v) || typeof v === 'string' ? v.length > 0 : v !== null && v !== undefined) || letNull;
      }).forEach(function (key) {
        if (data[key] !== null && data[key] !== undefined && data[key]._KEY != null) {
          data[key] = data[key]._KEY;
        }
        var key2 = key !== '_KEY' ? key.replace(/^_/, '') : key;
        temp[key2] = data[key];
      });
      return temp;
    };
    SbxCore.prototype.validateKeys = function (data) {
      var temp = [];
      if (Array.isArray(data)) {
        data.forEach(function (key) {
          if (typeof key === 'string') {
            temp.push(key);
          } else {
            temp.push(key._KEY);
          }
        });
      } else {
        if (typeof data === 'string') {
          temp.push(data);
        } else {
          temp.push(data._KEY);
        }
      }
      return temp;
    };
    SbxCore.environment = {};
    return SbxCore;
  }();
  var Find = /** @class */function () {
    function Find(model, domain) {
      this.query = new QueryBuilder().setDomain(domain).setModel(model);
      this.lastANDOR = null;
    }
    Find.prototype.compile = function () {
      return this.query.compile();
    };
    Find.prototype.newGroupWithAnd = function () {
      this.query.newGroup('AND');
      this.lastANDOR = null;
      return this;
    };
    Find.prototype.newGroupWithOr = function () {
      this.query.newGroup('OR');
      this.lastANDOR = null;
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereIsEqual = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '=', value);
      return this;
    };
    /**
     * @param {string} field
     * @return {Find}
     */
    Find.prototype.andWhereIsNotNull = function (field) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, 'IS NOT', null);
      return this;
    };
    /**
     * @param {string} field
     * @return {Find}
     */
    Find.prototype.andWhereIsNull = function (field) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, 'IS', null);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereGreaterThan = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '>', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereLessThan = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '<', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereIsIn = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, 'IN', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereGreaterOrEqualThan = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '>=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereLessOrEqualThan = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '<=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereIsNotEqual = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, '!=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereStartsWith = function (field, value) {
      this.lastANDOR = 'AND';
      value = value && value.length > 0 ? '%' + value : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereEndsWith = function (field, value) {
      this.lastANDOR = 'AND';
      value = value && value.length > 0 ? value + '%' : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereContains = function (field, value) {
      this.lastANDOR = 'AND';
      value = value && value.length > 0 ? '%' + value.split(' ').join('%') + '%' : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereIn = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, 'IN', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.andWhereNotIn = function (field, value) {
      this.lastANDOR = 'AND';
      this.query.addCondition(this.lastANDOR, field, 'NOT IN', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereIsEqual = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '=', value);
      return this;
    };
    /**
     * @param {string} field
     * @return {Find}
     */
    Find.prototype.orWhereIsNotNull = function (field) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, 'IS NOT', null);
      return this;
    };
    /**
     * @param {string} field
     * @return {Find}
     */
    Find.prototype.orWhereIsNull = function (field) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, 'IS', null);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereGreaterThan = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '>', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereLessThan = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '<', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereGreaterOrEqualThan = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '>=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereLessOrEqualThan = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '<=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereIsNotEqual = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, '!=', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereStartsWith = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      value = value && value.length > 0 ? '%' + value : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereEndsWith = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      value = value && value.length > 0 ? value + '%' : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereContains = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      // if the user sends null or empty, there will be no wildcar placed.
      value = value && value.length > 0 ? '%' + value.split(' ').join('%') + '%' : value;
      this.query.addCondition(this.lastANDOR, field, 'LIKE', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereIn = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, 'IN', value);
      return this;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    Find.prototype.orWhereNotIn = function (field, value) {
      this.lastANDOR = this.lastANDOR == null ? 'AND' : 'OR';
      this.query.addCondition(this.lastANDOR, field, 'NOT IN', value);
      return this;
    };
    /**
     * Reference Join between two model
     * @param {string} field column name of principal model
     * @param {string} referenceField column name of subQuery
     */
    Find.prototype.orWhereReferenceJoinBetween = function (field, referenceField) {
      return new ReferenceJoin(this, field, referenceField, 'OR');
    };
    /**
     * Reference Join between two model
     * @param {string} field column name of principal model
     * @param {string} referenceField column name of subQuery
     */
    Find.prototype.andWhereReferenceJoinBetween = function (field, referenceField) {
      return new ReferenceJoin(this, field, referenceField, 'AND');
    };
    Find.prototype.whereWithKeys = function (keys) {
      this.query.whereWithKeys(this.validateKeys(keys));
      return this;
    };
    /**
     * @param {string} field
     * @param asc
     * @return {Find}
     */
    Find.prototype.orderBy = function (field, asc) {
      if (asc === void 0) {
        asc = false;
      }
      this.query.orderBy(field, asc);
      return this;
    };
    Find.prototype.fetchModels = function (array) {
      this.query.fetchModels(array);
      return this;
    };
    Find.prototype.setPage = function (page) {
      this.query.setPage(page);
      return this;
    };
    Find.prototype.setPageSize = function (limit) {
      this.query.setPageSize(limit);
      return this;
    };
    Find.prototype.validateKeys = function (data) {
      var temp = [];
      if (Array.isArray(data)) {
        data.forEach(function (key) {
          if (typeof key === 'string') {
            temp.push(key);
          } else {
            temp.push(key._KEY);
          }
        });
      } else {
        if (typeof data === 'string') {
          temp.push(data);
        } else {
          temp.push(data._KEY);
        }
      }
      return temp;
    };
    Find.prototype.mapReverseFetchesResult = function (response, parentName, arrayName, completefetch) {
      if (parentName.indexOf('.') >= 0) throw Error('Only one level is allowed');
      completefetch = completefetch || [parentName];
      var newResponse = this.mapFetchesResult(response, completefetch);
      var objTemp = newResponse.results.reduce(function (objects, item) {
        objects[item[parentName]._KEY] = objects[item[parentName]._KEY] || item[parentName];
        objects[item[parentName]._KEY][arrayName] = objects[item[parentName]._KEY][arrayName] || [];
        item[parentName] = item[parentName]._KEY;
        objects[item[parentName]._KEY][arrayName].push(item);
      }, {});
      newResponse.results = Object.keys(objTemp).map(function (k) {
        return objTemp(k);
      });
      return newResponse;
    };
    /**
     * @param response the response of the server
     * @param {string[]} completefetch the array of fetch
     * @returns {any} the response with the union between fetch_results and results
     */
    Find.prototype.mapFetchesResult = function (response, completefetch) {
      if (response.fetched_results) {
        var fetch_1 = [];
        var secondfetch = {};
        for (var i = 0; i < completefetch.length; i++) {
          var index = 0;
          var temp = completefetch[i].split('.');
          if (fetch_1.indexOf(temp[0]) < 0) {
            fetch_1.push(temp[0]);
            index = fetch_1.length - 1;
          } else {
            index = fetch_1.indexOf(temp[0]);
          }
          if (temp.length === 2 && !secondfetch[fetch_1[index]]) {
            secondfetch[fetch_1[index]] = [];
          }
          if (temp.length === 2) {
            secondfetch[fetch_1[index]].push(temp[1]);
          }
        }
        for (var i = 0; i < response.results.length; i++) {
          for (var j = 0; j < fetch_1.length; j++) {
            for (var mod in response.fetched_results) {
              if (response.fetched_results[mod][response.results[i][fetch_1[j]]]) {
                response.results[i][fetch_1[j]] = response.fetched_results[mod][response.results[i][fetch_1[j]]];
                if (secondfetch[fetch_1[j]]) {
                  for (var k = 0; k < secondfetch[fetch_1[j]].length; k++) {
                    var second = secondfetch[fetch_1[j]][k];
                    for (var mod2 in response.fetched_results) {
                      if (response.fetched_results[mod2][response.results[i][fetch_1[j]][second]]) {
                        response.results[i][fetch_1[j]][second] = response.fetched_results[mod2][response.results[i][fetch_1[j]][second]];
                        break;
                      }
                    }
                  }
                }
                break;
              }
            }
          }
        }
      }
      return response;
    };
    return Find;
  }();
  var ReferenceJoin = /** @class */function () {
    function ReferenceJoin(find, field, referenceField, type) {
      this.find = find;
      this.field = field;
      this.referenceField = referenceField;
      if (type === 'AND') {
        this.find.andWhereIn(this.field, '@reference_join@');
      } else {
        this.find.orWhereIn(this.field, '@reference_join@');
      }
    }
    /**
     * set model to Join
     * @param {string} referenceModel
     * @return {FilterJoin}
     */
    ReferenceJoin.prototype.in = function (referenceModel) {
      return new FilterJoin(this.find, this.field, this.referenceField, referenceModel);
    };
    return ReferenceJoin;
  }();
  var FilterJoin = /** @class */function () {
    function FilterJoin(find, field, referenceField, referenceModel) {
      this.find = find;
      this.field = field;
      this.referenceField = referenceField;
      this.referenceModel = referenceModel;
    }
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     */
    FilterJoin.prototype.filterWhereIsEqual = function (value) {
      this.find.query.setReferenceJoin('=', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereIsNotNull = function () {
      this.find.query.setReferenceJoin('IS NOT', this.field, this.referenceField, this.referenceModel, null);
      return this.find;
    };
    /**
     * @param {string} field
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereIsNull = function () {
      this.find.query.setReferenceJoin('IS', this.field, this.referenceField, this.referenceModel, null);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereGreaterThan = function (value) {
      this.find.query.setReferenceJoin('>', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereLessThan = function (value) {
      this.find.query.setReferenceJoin('<', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereGreaterOrEqualThan = function (value) {
      this.find.query.setReferenceJoin('>=', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereLessOrEqualThan = function (value) {
      this.find.query.setReferenceJoin('<=', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereIsNotEqual = function (value) {
      this.find.query.setReferenceJoin('!=', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereLike = function (value) {
      this.find.query.setReferenceJoin('LIKE', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereIn = function (value) {
      this.find.query.setReferenceJoin('IN', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    /**
     * @param {string} field
     * @param value
     * @return {Find}
     * @constructor
     */
    FilterJoin.prototype.FilterWhereNotIn = function (value) {
      this.find.query.setReferenceJoin('NOT IN', this.field, this.referenceField, this.referenceModel, value);
      return this.find;
    };
    return FilterJoin;
  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = SbxCore;else {
    var global;
    try {
      global = Function('return this')() || (42, eval)('this');
    } catch (e) {
      global = window;
    }

    global.SbxCore = SbxCore;
  }
})();
//# sourceMappingURL=sbxcore.umd.js.map
